<script lang="ts">
      import MenuButton from './side/MenuButton.svelte'

      import type { MenuItem } from './Menu'
      import MenuInline from './inline/MenuInline.svelte'
      import { getPayloadContext } from '../context/ts/PayloadGlobals.svelte'
      import { getLocaleContext } from '../locale/ts/Locale.svelte'
      import { untrack } from 'svelte'

      //let items: Array<MenuItem> = $state([
      //      {
      //            label: 'NEWS',
      //            type: 'link',
      //            link: '',
      //      },
      //      {
      //            label: 'PROGRAMME',
      //            type: 'menu',
      //            items: [
      //                  {
      //                        label: 'PROGRAMME',
      //                        type: 'link',
      //                        link: '',
      //                  },
      //                  {
      //                        label: 'CATALOGUE',
      //                        type: 'link',
      //                        link: '',
      //                  },
      //            ],
      //      },
      //      {
      //            label: 'MEDIA',
      //            type: 'menu',
      //            items: [
      //                  {
      //                        label: 'VIDEO',
      //                        type: 'link',
      //                        link: '',
      //                  },
      //                  {
      //                        label: 'AUDIO',
      //                        type: 'link',
      //                        link: '',
      //                  },
      //            ],
      //      },
      //])

      let items: Array<MenuItem> = $state([])

      const locale = getLocaleContext()
      const payloadContext = getPayloadContext()

      function localizeLink(link: any): any {
            if (link.type == 'menu')
                  return {
                        ...link,
                        items: localizeLinks(link.items),
                  }
            if (link.type == 'internal')
                  return {
                        ...link,
                        slug: locale.getLocaleSlug(link.slug),
                  }
            return {
                  ...link,
                  link: locale.getLocaleLink(link.link),
            }
      }

      function localizeLinks(links: any[]) {
            return links.map((l) => localizeLink(l))
      }

      $effect(() => {
            const _items = payloadContext.navigation

            const res = localizeLinks(_items)
            untrack(() => {
                  payloadContext.setLocalizedNavigation(res)
            })
      })

      let { class: className = '' } = $props()
</script>

<MenuButton class="{className} h-full lg:hidden"></MenuButton>
<MenuInline class="{className} h-full lg:flex hidden" items={payloadContext.localizedNavigation}></MenuInline>

<style>
</style>
